import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { GRAPHQL_GATEWAY_PATH } from '../../../common/types/query';
export class ActivityClient {
  constructor(clientVersion, product, headers, baseUrl) {
    _defineProperty(this, "product", 'unknown');
    _defineProperty(this, "baseUrl", GRAPHQL_GATEWAY_PATH);
    if (product) {
      this.product = product;
    }
    this.clientVersion = clientVersion;
    this.headers = headers !== null && headers !== void 0 ? headers : {};
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
  }
}